import type ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import type { IModuleViewModel } from "../../types";
import { ConductorOneChildActive, Router } from "@frui.ts/screens/dist";
import LocalizationService from "services/localizationService";
import { computed } from "mobx";
import { Modules } from "config";
import AdHocReportsListViewModel from "./adHocReports/adHocReportsListViewModel";
import ExternalReportsViewModel from "./externalReports/externalReportsViewModel";
import InternalReportsViewModel from "./internalReports/internalReportsViewModel";
import SecurityService from "services/securityService";

const navigationName = "reporting";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [AdHocReportsListViewModel, ExternalReportsViewModel, InternalReportsViewModel],
})
export default class ReportingViewModel extends ConductorOneChildActive<ScreenBase> implements IModuleViewModel {
  showChildrenSubmenu = true;

  constructor(
    private localizationService: LocalizationService,
    private adHocReportsListViewModel: AdHocReportsListViewModel,
    private externalReportsViewModel: ExternalReportsViewModel,
    private internalReportsViewModel: InternalReportsViewModel,
    private securityService: SecurityService
  ) {
    super();
    this.navigationName = navigationName;

    if (this.securityService.allowTo("charges.reports")) {
      this.children.push(this.externalReportsViewModel, this.internalReportsViewModel, this.adHocReportsListViewModel);
    }
  }

  @computed
  get name() {
    return this.translate("name");
  }

  protected onInitialize(): Promise<any> | void {
    if (!this.activeChild) {
      this.tryActivateChild(this.children[0]);
    }

    return super.onInitialize();
  }

  closeChild(child: ScreenBase) {
    return false;
  }

  translate(code: string) {
    return this.localizationService.translateModule(Modules.timeCharges, `reporting.${code}`);
  }
}
